import {
    Component, 
    Input,
    HostListener,
    ElementRef
}                               from "@angular/core";

import { 
    textFormat,
    textNumeric
}                               from "../../functions";
import {
    CtmTableData
}                               from "../../models";
import {
    CtmTranslateService  
}                               from "../../services"

import { CONSTANT }         from "../../../_custom";

@Component({
    selector: "ctm-table",
    template: require('./table.html'),
})
export class CtmTable {
    private _showInformation: boolean = false;
    private _showDisplayPage: boolean = false;
    private _showPagging: boolean = false;
    private _tableHover: boolean = false;
    private _tableStriped: boolean = false;
    private _fixHeader: boolean = false;
    private _fixHeight: boolean = false;
    
    private _tableData: CtmTableData;
    private _headerIsFixed: boolean = false;

    constructor(
        private _element: ElementRef,
        private translate: CtmTranslateService
    ) {
    }
  
    ngOnInit() {
        let mscroll = $(this._element.nativeElement.querySelector(".table-data .horizontal-scroll"));
        let hscroll = $(this._element.nativeElement.querySelector(".table-header .horizontal-scroll"));
        let fscroll = $(this._element.nativeElement.querySelector(".table-footer .horizontal-scroll"));

        mscroll.unbind("scroll");
        mscroll.bind("scroll", function() {
            hscroll.scrollLeft(mscroll.scrollLeft());
            fscroll.scrollLeft(mscroll.scrollLeft());

            $(".md2-autocomplete-menu").hide();
        });
    }

    @HostListener("window:resize")
    public onWindowResize():void {
        this.fixTableHeader();
    }
    
    @HostListener("window:scroll")
    public onWindowScroll():void {
        this.fixTableHeader();
    }
  
    @Input("show-information")
    public get showInformation(): boolean {
        return this._showInformation;
    }
    public set showInformation(value: boolean) {
        this._showInformation = value;
    }
  
    @Input("show-display-page")
    public get showDisplayPage(): boolean {
        return this._showDisplayPage;
    }
    public set showDisplayPage(value: boolean) {
        this._showDisplayPage = value;
    }
  
    @Input("show-pagging")
    public get showPagging(): boolean {
        return this._showPagging;
    }
    public set showPagging(value: boolean) {
        this._showPagging = value;
    }
  
    @Input("table-data")
    public get tableData(): CtmTableData {
        return this._tableData;
    }
    public set tableData(value: CtmTableData) {
        this._tableData = value;
        if (this._tableData != undefined) {
            this._tableData.scrollLast = () => {
                if (this._fixHeight) {
                    setTimeout(() => {
                        let tableDCtrl = this._element.nativeElement.querySelector('.table-data');
                        let scroll = $(tableDCtrl).find(".horizontal-scroll");
                        scroll.scrollTop(scroll[0].scrollHeight);
                    }, 0);
                }
                else {
                    let tableHCtrl = this._element.nativeElement.querySelector('.table-header');
                    let tableDCtrl = this._element.nativeElement.querySelector('.table-data');
        
                    let top = 0, c;
        
                    if (this._headerIsFixed) {
                        c = tableDCtrl;
                    }
                    else {
                        c = tableHCtrl;
                    }
        
                    do {
                        top += c.offsetTop  || 0;
                        c = c.offsetParent;
                    } while(c);
        
                    let pheader = $(document.body).find(".page-header").outerHeight();
                    
                    let height = $(tableDCtrl).outerHeight();
                    
                    let scroll = $(window).scrollTop() + pheader;
                    let wheight = $(window).outerHeight();

                    if ((top + height) > (scroll + wheight)) {
                        $("html, body").animate({ 
                            scrollTop: (top + height) + "px" 
                        }, { 
                            duration: 1000 
                        });
                    }
                }
            };
        }
    }
    
    @Input("table-hover")
    public get tableHover(): boolean {
        return this._tableHover;
    }
    public set tableHover(value: boolean) {
        this._tableHover = value;
    }
    
    @Input("table-striped")
    public get tableStriped(): boolean {
        return this._tableStriped;
    }
    public set tableStriped(value: boolean) {
        this._tableStriped = value;
    }
      
    @Input("table-fix-header")
    public get tableFixHeader(): boolean {
        return this._fixHeader;
    }
    public set tableFixHeader(value: boolean) {
        this._fixHeader = value;
    }
    @Input("table-fix-height")
    public get tableFixHeight(): boolean {
        return this._fixHeight;
    }
    public set tableFixHeight(value: boolean) {
        this._fixHeight = value;
    }


    private _onDisplayPageChange(data) {
        this.tableData.pageNumber = 1;
        this.tableData.loadData(null);
    }
    private _onPageChange(page) {
        if (page.current)
            return;

        this.tableData.pageNumber = page.number;
        this.tableData.loadData(null);
    }
  
    private _tableInformation() {
        let info = "";
        if (this.tableData.totalRecords > 0) {
            if (this.showPagging == true) {
                info = textFormat(
                    this.translate.instant("tableRecordInfo", "COMMON"),
                    [
                        textNumeric(this.tableData.pagging.from, { comma: true }),
                        textNumeric(this.tableData.pagging.to, { comma: true }),
                        textNumeric(this.tableData.totalRecords, { comma: true })
                    ]);
            }
            else {
                info = textFormat(
                    this.translate.instant("tableRecordInfoNoPaging", "COMMON"),
                    [
                        textNumeric(this.tableData.totalRecords, { comma: true })
                    ]);
            }
        }

        return info;
    }
  
    private fixTableHeader() {
        if (this.fixTableHeader) { 
            let tableHCtrl = this._element.nativeElement.querySelector('.table-header');
            let tableDCtrl = this._element.nativeElement.querySelector('.table-data');

            let topH = 0, topD = 0, cH, cD;

            cH = tableHCtrl;
            do {
                topH += cH.offsetTop  || 0;
                cH = cH.offsetParent;
            } while(cH);

            cD = tableDCtrl;
            do {
                topD += cD.offsetTop  || 0;
                cD = cD.offsetParent;
            } while(cD);

            let pheader = $(document.body).find(".page-header").outerHeight();
            let scroll = $(window).scrollTop() + pheader;
            let height = $(tableDCtrl).outerHeight();
            let width = $(tableDCtrl).width();
            let hheight = $(tableHCtrl).outerHeight();

            let start = topD - hheight;
            let end = topD + height;
            if (topH != pheader) {
                start = topH;
                end = topH + height;
            }

            if (start - scroll <= 0
                && end - scroll > 0) {
                this._headerIsFixed = true;
                $(tableDCtrl).css({
                    "margin-top":  hheight
                });
                $(tableHCtrl).css({
                    width: width + "px"
                });
            }
            else {
                this._headerIsFixed = false;
                $(tableDCtrl).css({
                    "margin-top":  "0"
                });
                $(tableHCtrl).css({
                    width: "100%"
                });
            }
            
        }
    }

    private get defaultDisplayPage(): number {
        return CONSTANT.DISPLAY_PAGE;
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/components/table/table.ts